import { render, staticRenderFns } from "./NACharts.component.vue?vue&type=template&id=5450bbbb&scoped=true&"
import script from "./NACharts.component.vue?vue&type=script&lang=js&"
export * from "./NACharts.component.vue?vue&type=script&lang=js&"
import style0 from "./NACharts.component.vue?vue&type=style&index=0&id=5450bbbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450bbbb",
  null
  
)

export default component.exports